var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.504 1.67a3.333 3.333 0 0 1 2.887 5h3.78v1.666h-1.667v8.333c0 .46-.373.833-.833.833H3.337a.833.833 0 0 1-.833-.833V8.336H.837V6.669l3.78.001a3.333 3.333 0 0 1 5.388-3.872 3.32 3.32 0 0 1 2.5-1.129ZM9.171 8.335h-5v7.5h5v-7.5Zm6.666 0h-5v7.5h5v-7.5Zm-8.333-5a1.667 1.667 0 0 0-.124 3.329l.124.004h1.667V5.002c0-.834-.614-1.526-1.415-1.647l-.128-.015-.124-.004Zm5 0c-.879 0-1.598.68-1.662 1.542l-.005.124V6.67h1.667c.879 0 1.598-.68 1.662-1.542l.005-.125c0-.92-.746-1.666-1.667-1.666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftLine);
export default __webpack_public_path__ + "static/media/gift-line.88d2d61a5612efa215277486eff5a659.svg";
export { ForwardRef as ReactComponent };